
function LoaderShow1To2Min() {

    

    const textStyle = {
        marginTop: '30px',
        fontSize: '18px',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
    };

    return (
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
                <div className="col-sm-12">
                    <div className="card h-100">
                        <div
                            className="card-body d-flex flex-column justify-content-center align-items-center"
                            style={{ minHeight: '400px' }}
                        >
                            {/* Loader animation */}
                            <div className="containeranimate">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </div>

                            {/* Text */}
                            <div style={textStyle}>
                                Please wait... This may take about 1–2 minutes.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoaderShow1To2Min;